import { z } from "zod";
/**
 * Factory function to create CreateExpenseCategoryValidator with translations
 */
export const createCreateExpenseCategoryValidator = (t) => z
    .object({
    name: z
        .string()
        .min(1, t("validation.categories.nameRequired"))
        .max(255, t("validation.categories.nameTooLong")),
    description: z
        .union([
        z.string().max(500, t("validation.categories.descriptionTooLong")),
        z.null(),
        z.undefined(),
    ])
        .optional()
        .transform((val) => val ?? ""),
    color: z
        .union([
        z.string().regex(/^#[0-9A-F]{6}$/i, t("validation.categories.colorInvalid")),
        z.literal(""),
    ])
        .nullish(),
})
    .transform((data) => {
    // Remove color if it's null, undefined, or empty string
    if (data.color === null || data.color === undefined || data.color === "") {
        const { color, ...rest } = data;
        return rest;
    }
    return data;
});
/**
 * Factory function to create UpdateExpenseCategoryValidator with translations
 */
export const createUpdateExpenseCategoryValidator = (t) => z.object({
    name: z
        .string()
        .min(1, t("validation.categories.nameRequired"))
        .max(255, t("validation.categories.nameTooLong"))
        .optional(),
    description: z
        .union([
        z.string().max(500, t("validation.categories.descriptionTooLong")),
        z.null(),
        z.undefined(),
    ])
        .optional()
        .transform((val) => val ?? ""),
    color: z
        .string()
        .regex(/^#[0-9A-F]{6}$/i, t("validation.categories.colorInvalid"))
        .optional(),
});
